<div class="navbar navbar-fixed navbar-toggleable-sm navbar-deloitte-light">
    <div class="navbar-container justify-content-between">
        <div class="navbar-brand" href="#">
            <span class="navbar-mobile-title">
                Map
            </span>
        </div>
    </div>
</div>

<div class="container">

    <div class="row">
        <div id="mapcontainer" class="col-12 col-md-8 mt-5">
            <div class="card-header bg-info text-white">
                <p class="h5 mb-0">World map</p>
            </div>
            <div class="card">
                <div class="card-block">
                    <map name="map"></map>
                </div>
            </div>
        </div>

        <div class="col-12 col-md-4 mt-5">
            <div class="card">
                <div class="card-header bg-info text-white">
                    <p class="h5 mb-0">Filters</p>
                </div>
                <div class="card-block">
                    @for (dropdown of dropDownsToRender; track dropdown) {
                    <div>
                        <fieldset class="form-group">
                            <label class="textBody--xs text-gray-10"><strong>{{dropdown.label}}</strong></label><!--<span class="glyphicon glyphicon-info-sign" uib-popover="dropdown.helpText" popover-append-to-body="true" popover-trigger="'outsideClick'" popover-placement="l-"></span>-->
                            @if (dropdown.presentationTypeId==1) {
                            <ng-select [id]="'dropdown-' + dropdown.id" [clearable]="false"
                                       [items]="dropdown?.dropDownItems || []"
                                       [ngModel]="dropdown?.selectedDropDownItem?.id"
                                       (ngModelChange)="onDashboardDropDownSelected($event, dropdown)"
                                       placeholder="Select an option"
                                       bindLabel="text"
                                       bindValue="id">
                            </ng-select>
                            }
                            @if (dropdown.presentationTypeId==2) {
                            <ul class="mapkey m-0">
                                @for (item of dropdown?.dropDownItems; track item) {
                                <li [value]="item.id" (click)="keyItemSelected(dropdown, item.id)" [ngClass]="{'active': item.id == keySelected }">
                                    <div class="row">
                                        <div class="col col-auto">
                                            <span class="mapkey__key" [ngStyle]="{'background': item.colour}"></span>
                                        </div>
                                        <div class="col pl-0">{{item.text}}</div>
                                    </div>
                                </li>
                                }
                            </ul>
                            }
                        </fieldset>
                    </div>
                    }

                    <div id="region-countries">
                        <fieldset class="form-group">
                            <label class="textBody--xs text-gray-10"><strong>Region</strong></label>
                            <ng-select id="regionSelector" [clearable]="true"
                                       [items]="itemsRegions"
                                       (ngModelChange)="onRegionSelected($event)"
                                       [ngModel]="selectedRegion"
                                       (clear)="onRegionRemoved($event)"
                                       placeholder="No region selected"
                                       bindLabel="text"
                                       bindValue="id">
                            </ng-select>
                        </fieldset>
                        <fieldset class="form-group">
                            <label class="textBody--xs text-gray-10"><strong>Location</strong></label>
                            <ng-select id="countrySelector" [clearable]="true"
                                       [items]="itemsCountries"
                                       [ngModel]="selectedCountry"
                                       (ngModelChange)="onCountrySelected($event)"
                                       (clear)="onCountryRemoved($event)"
                                       placeholder="No location selected"
                                       bindLabel="text"
                                       bindValue="id">
                            </ng-select>
                        </fieldset>
                    </div>
                </div>
                <div id="reset-filters" class="card-footer p-3">
                    <button (click)="onResetClicked()" class="btn btn-info btn-block">Reset filters</button>
                </div>
            </div>
        </div>
    </div>
</div>